import { useEffect, useState, useCallback } from 'react';
import { supabaseStats } from '../lib/supabaseClient';
import { AllPlatformStats } from '../types';

// FIX #1: Type Safety Improvement
interface PlatformStatRow {
  platform: keyof AllPlatformStats; 
  stats: AllPlatformStats[keyof AllPlatformStats]; 
}

export const usePlatformStats = () => {
  const [stats, setStats] = useState<AllPlatformStats>({});
  const [loading, setLoading] = useState(true);

  const formatNumber = useCallback((num: number | undefined | null) => {
    if (num === undefined || num === null) return '...'; 
    return num.toLocaleString('en-US');
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchStats = async () => {
      try {
        const { data, error } = await supabaseStats
          .from('platform_stats')
          .select('platform, stats');

        if (error) {
          console.error('Error fetching stats:', error);
          return;
        }

        if (isMounted && data) {
          const statsMap: AllPlatformStats = {};

          // FIX #4: Type Safety
          (data as unknown as PlatformStatRow[]).forEach((row) => {
            const key = row.platform; // keyof AllPlatformStats
            
            if (key && row.stats) {
              // Assigning with type assertion
              statsMap[key] = row.stats as any;
            }
          });

          setStats(statsMap);
        }
      } catch (err) {
        console.error('Unexpected error:', err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchStats();

    return () => {
      isMounted = false;
    };
  }, []);

  return { stats, loading, formatNumber };
};